module.exports = __webpack_public_path__ + "fonts/3MCircularTT-BookItalic.02ce9465.woff";